import axios from 'axios';
import { getUsersQuery } from './queries';
import { buildExpressQuery, buildLoopbackQuery } from './queries/builders';
import { resolveId } from '../../utils';
import Split from '../split';

const getUserSettings = (id) =>
    new Promise((resolve, reject) => {
        const queryBuilder = Split.getBooleanTreatment('use_express_auth_endpoints') ? buildExpressQuery : buildLoopbackQuery;
        const userQuery = getUsersQuery({ ids: [id], queryBuilder });
        const userRequest = axios.get(userQuery);
        userRequest
            .then((userResponse) => {
                const users = Array.isArray(userResponse.data) ? userResponse.data.filter(Boolean).map(resolveId) : [];
                if (users.length === 0) {
                    reject(new Error('User settings not found'));
                    return;
                }
                // eslint-disable-next-line camelcase
                const { notifications = [], custom_alerts = [] } = users[0]?.settings ?? {};
                resolve({ notifications, custom_alerts });
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to process request'));
            });
    });

export default getUserSettings;
